const routes = [
  {
    path: '/administracao/usuario',
    name: 'user',
    component: () => import('@/views/administracao/usuario/Usuario.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários' }] },
  },
  {
    path: '/administracao/usuario/novo',
    name: 'userNew',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/:id/usuario/editar',
    name: 'userUpdate',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos',
    name: 'userGroup',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioPai.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/novo',
    name: 'userGroupNew',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }, { title: 'Novo' }],
    },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/:id/editar',
    name: 'userGroupUpdate',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Administração' }, { title: 'Usuários', name: 'user' }, { title: 'Grupos' }, { title: 'Editar' }],
    },
  },
  {
    path: '/administracao/grupo',
    name: 'group',
    component: () => import('@/views/administracao/grupo/Grupo.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/grupo/novo',
    name: 'groupNew',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/grupo/:id/editar',
    name: 'groupUpdate',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/grupo/:id_group/regras',
    name: 'acl',
    component: () => import('@/views/administracao/grupo/acl/AclPai.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Grupos' }, { title: 'ACL' }] },
  },
  {
    path: '/administracao/cargo',
    name: 'userRole',
    component: () => import('@/views/administracao/cargo/Cargo.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Cargos' }] },
  },
  {
    path: '/administracao/cargo/novo',
    name: 'userRoleNew',
    component: () => import('@/views/administracao/cargo/CargoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Cargos', name: 'userRole' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/cargo/:id/editar',
    name: 'userRoleUpdate',
    component: () => import('@/views/administracao/cargo/CargoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Cargos', name: 'userRole' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/departamento',
    name: 'userDepartment',
    component: () => import('@/views/administracao/departamento/Departamento.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Departamentos' }] },
  },
  {
    path: '/administracao/departamento/novo',
    name: 'userDepartmentNew',
    component: () => import('@/views/administracao/departamento/DepartamentoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Departamentos', name: 'userDepartment' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/departamento/:id/editar',
    name: 'userDepartmentUpdate',
    component: () => import('@/views/administracao/departamento/DepartamentoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Departamentos', name: 'userDepartment' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/programa',
    name: 'screen',
    component: () => import('@/views/administracao/programa/Programa.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }] },
  },
  {
    path: '/administracao/programa/novo',
    name: 'screenNew',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/programa/:id/editar',
    name: 'screenUpdate',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administração' }, { title: 'Programa' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/notificacoes',
    name: 'notificationHistory',
    component: () => import('@/views/administracao/notificacao/Notificacoes.vue'),
    meta: { breadcrumb: [{ title: 'Fundação' }, { title: 'Notificações' }] },
  },
  {
    path: '/conta-azul/empresas/nova',
    name: 'contaAzulCompanyNew',
    component: () => import('@/views/contaAzul/EmpresaContaAzulNew.vue'),
    meta: { breadcrumb: [{ title: 'Conta Azul' }, { title: 'Empresas Conta Azul', name: 'contaAzulCompany' }, { title: 'Novo' }] },
  },
  {
    path: '/conta-azul/empresas/:id/editar',
    name: 'contaAzulCompanyUpdate',
    component: () => import('@/views/contaAzul/EmpresaContaAzulNew.vue'),
    meta: { breadcrumb: [{ title: 'Conta Azul' }, { title: 'Empresas Conta Azul', name: 'contaAzulCompany' }, { title: 'Editar' }] },
  },
]

export default routes
